import {PayloadAction} from "@reduxjs/toolkit";
import {APP_LANGUAGE_SET} from "../../state/app/appActions";
import {setModuleConfigs} from "../../state/module-configs/moduleConfigsActions";
import {getModuleConfigs} from "../../state/module-configs/utils";
import {INIT} from "../../state/rootActions";

const moduleConfigsMiddlewareFactory =
  t =>
  ({getState, dispatch}) =>
  next =>
  (action: PayloadAction<any>) => {
    const res = next(action);

    if (action.type === INIT || action.type === APP_LANGUAGE_SET) {
      const {_moduleConfigFiles} = getState().moduleConfigs;
      const moduleConfigs = getModuleConfigs(_moduleConfigFiles, getState, dispatch, t);

      dispatch(setModuleConfigs(moduleConfigs));
    }

    return res;
  };

export default moduleConfigsMiddlewareFactory;
